import { useSearchParams } from "react-router-dom";
import Invoices from "./Invoices";

const InvoicesPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  let search = searchParams.get("search");
  let status = searchParams.get("status");

  return <Invoices search={search} status={status ?? "unpaid"} />;
};

export default InvoicesPage;
